import { getOrganisationDomain } from '../utils/getOrganisationDomain';

export const MIN_PASSWORD_LENGTH = 5;

export const COMMENTS_SIZE = 25;

export const ORG_TAGS_SIZE_LIMIT = 250;

export const ORG_TAGS_NAME_LENGTH_LIMIT = 100;

export const STORY_CARD_TEMPLATES_LIMIT = 50;

export const CHAT_LOAD_MESSAGES_LIMIT = 25;

export const CHAT_TYPING_USERS_LIMIT = 5;

export const CARDS_TO_BLOCK = [
  { storyId: 616269, cardId: 46624619 },
  { storyId: 616269, cardId: 46624356 },
  { storyId: 616269, cardId: 46624365 },
  { storyId: 616269, cardId: 46624370 },
  { storyId: 616269, cardId: 46624445 },
  { storyId: 616269, cardId: 46624607 },
  { storyId: 616269, cardId: 46624619 },
  //for testing purposes
  { storyId: 60821, cardId: 22123043 },
  { storyId: 60821, cardId: 22123042 },
  { storyId: 60821, cardId: 22123041 },
];

export const LOCALES = [
  { id: 1, code: 'en-US' },
  { id: 2, code: 'de-DE' },
];

export const DATE_INPUT_FORMAT = 'dd.MM.yyyy';

export const TIME_INPUT_FORMAT = 'HH:mm';

export const DATE_TIME_FORMAT = 'dd.MM.yyyy, HH:mm';

//STORAGE
export const COLLAPSE_STORAGE_KEY = 'collapse';

export const CATEGORY_TEMPLATES_COLLAPSE_STORAGE_KEY = 'categoryTemplatesCollapse';

export const FREE_LOGIN_USER_ID_STORAGE_KEY = 'freeLoginUserId';

export const POST_IN_STORAGE_KEY = 'postIn';

export const NOTIFICATIONS_STORAGE_KEY = 'notifications';

export const LATEST_STORY_CARDS_STORAGE_KEY = 'latestStoryCards';

//COOKIE
export const MZ_ACCOUNT_COOKIE_KEY = 'mz-account';

export const FREE_LOGIN_COOKIE_KEY = 'freeLogin';

export const COPY_CUT_COOKIE_KEY = 'copyCut';

export const COPY_EVENT_COOKIE_KEY = 'copyEvent';

export const USER_DIRECTORY_READER_COOKIE_KEY = `userDirectoryReader_${getOrganisationDomain()}`;

export const STORY_TAB_ADMIN_COOKIE_KEY = 'storyTabAdmin';

export const STORY_TAB_ITEMS_ADMIN_COOKIE_KEY = `storyTabItemsAdmin_${getOrganisationDomain()}`;

export const NEWS_FEED_ADMIN_COOKIE_KEY = `newsFeedAdmin_${getOrganisationDomain()}`;

export const COMMENTS_FEED_ADMIN_COOKIE_KEY = `commentsFeedAdmin_${getOrganisationDomain()}`;

export const TAGS_FEED_ADMIN_COOKIE_KEY = `tagsFeedAdmin_${getOrganisationDomain()}`;

export const SEARCH_ADMIN_COOKIE_KEY = `searchAdmin_${getOrganisationDomain()}`;

export const USER_FEED_COOKIE_KEY = 'userFeed';

export const USER_DEVICE_COOKIE_KEY = 'userDevice';

export const NOTIFICATIONS_PERMISSION_COOKIE_KEY = 'notificationsPermission';

export const NOTIFICATIONS_ADMIN_COOKIE_KEY = 'notificationsAdmin';

export const ABUSE_REPORT_COOKIE_KEY = 'abuseReport';

export const DSA_REPORT_COOKIE_KEY = 'DSAReport';

export const FORGOT_PASSWORD_COOKIE_KEY = 'forgotPassword';

export const LOGIN_REDIRECT_COOKIE_KEY = 'loginRedirect';

export const AUDIO_PLAYER_COOKIE_KEY = 'audioPlayer';

export const PUBNUB_COOKIE_KEY = 'pubNub';

export const ORG_DASH_USERS = `orgDashUsers_${getOrganisationDomain()}`;

export const ORG_DASH_ANALYTICS = `orgDashAnalytics_${getOrganisationDomain()}`;

export const REFERRAL_COOKIE_KEY = 'referral';

export const EVENTS_FEED_COOKIE_KEY = `eventsFeed_${getOrganisationDomain()}`;

export const EVENTS_FEED_ADMIN_COOKIE_KEY = `eventsFeedAdmin_${getOrganisationDomain()}`;

export const MY_TOPICS_COOKIE_KEY = 'myTopics';
